import { useSystem } from 'api/systems/systems.api'
import React, { ReactElement, useMemo } from 'react'
import { useAuth } from 'ui/components/AuthContext/AuthContext'
import DeviationSettings from 'ui/uiConfig/anchorComponents/FollowupProduction/DeviationSettings/DeviationSettings'
import { optimizeViewRange } from 'views/OptimizeView/store/optimizeViewStore'

export default function ActiveDeviationSettings(): ReactElement | null {
  const { systemId } = useAuth()
  const { data: activeSystem } = useSystem({ id: systemId })

  const [startTime, endTime] = useMemo(() => optimizeViewRange(false, { type: 'week' }), [])

  // Only show active deviation settings for legacy opt models, i.e. no digital twin
  const digitalTwinUid = useMemo(() => activeSystem?.primary_digital_twin?.uid, [activeSystem])
  if (digitalTwinUid) {
    return null
  }

  return (
    <div className="flex items-center">
      <DeviationSettings startTime={startTime} endTime={endTime} shrink />
    </div>
  )
}
